/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChatReplyAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 2v9h-2V4H4v16h.501L7.5 16H11v2H8.499L5.5 22H2V2zm-4.293 8.707L15.414 13H22v5h-2v-3h-4.586l2.293 2.293-1.414 1.414L11.586 14l4.707-4.707z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChatReplyAlt as ChatReplyAlt };
